import { render } from "./BlogGridSidebar.vue?vue&type=template&id=200a7a2d"
import script from "./BlogGridSidebar.vue?vue&type=script&lang=js"
export * from "./BlogGridSidebar.vue?vue&type=script&lang=js"

import exportComponent from "/home/afreet/public_html/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__